import gql from 'graphql-tag';

export const InstitutionalInformation = gql`
  query InstitutionalInformation(
    $campus: String!
    $career: String!
    $zona: String!
  ) {
    institutionalInformation {
      institutionalInformationStudent(
        campus: $campus
        career: $career
        zona: $zona
      ) {
        id
        name
        order
        deployed
        files {
          idFile
          career
          campus
          title
          nameFile
          orderFile
        }
      }
    }
  }
`;
